import { render, staticRenderFns } from "./UnSavedMessage.vue?vue&type=template&id=531281fe&scoped=true"
import script from "./UnSavedMessage.vue?vue&type=script&lang=ts"
export * from "./UnSavedMessage.vue?vue&type=script&lang=ts"
import style0 from "./UnSavedMessage.vue?vue&type=style&index=0&id=531281fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531281fe",
  null
  
)

export default component.exports